<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Reconocimiento de Juárez a los combatientes</h2>
    <img @click="imageClicked(0)" src="galerias/sala2/S2_G7.png" class="mainphoto"/>
    <p class="photo-description">Título: <b>Medalla</b><br>
      Autor: Anónimo<br>
      Año: S. XIX <br>
      Técnica: Troquelada en plata<br>
      Medidas: 7 x 2 cm.<br>
      Colección: Museo Regional “Casa de Alfeñique”<br>
    </p>
    <p>Atendiendo la solicitud del Gral. Zaragoza, el Presidente Juárez expidió un decreto para honrar con medallas de oro a todos los soldados que pelearon para defender la patria en las batallas de Acultzingo, Atlixco y Puebla, lo que se cumplió en una sentida ceremonia, 4 de diciembre de 1862</p>
    <p>Cabe mencionar que el Gral. Ignacio Zaragoza no pudo ver cumplida su solicitud, ya que a causa de tifoidea murió el 8 de septiembre.</p>
    <p>Desde 1862 hasta la actualidad, la Batalla del 5 de mayo, es considerada una fecha nacional emblemática que ha trascendido fronteras, ya que representa el triunfo de la libre determinación de los pueblos para decidir su condición política, económica, social y su forma de gobierno.</p>
    <h3>Relación Oficial de algunos participantes en la Batalla</h3>
    <img @click="imageClicked(1)" src="galerias/sala2/S2_G7_SUB.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Retrato de Porfirio Díaz</b><br>
      Autor: Anónimo<br>
      Año: S. XIX <br>
      Técnica: Óleo sobre tela<br>
      Medidas: 121 X 92 cm<br>
      Colección: Museo Regional “Casa de Alfeñique”<br>
    </p>
    <p>
      General de División en Jefe, Ignacio Zaragoza<br>
      <b>GENERALES DE BRIGADA.</b> José Ma. Arteaga, Felipe B. Berriozábal, Francisco Lamadrid, Ignacio Mejía y Miguel Negrete.<br>
      <b>GENERAL CORONEL DE INFANTERÍA.</b> Porfirio Díaz<br>
      <b>CORONEL DE CABALLERÍA.</b> Capitán 1° de artillería, Manuel Inclán.<br>
      <b>CORONEL DE CABALLERÍA.</b> Pedro G. Guccione<br>
      <b>TENIENTE CORONEL COMANDANTE.</b> Antonio Domínguez<br>
      <b>CORONELES DE INFANTERÍA.</b> Juan M. Kanfer, Juan Caamaño, Amado Santacruz Madero, Hipólito R. Ortíz, Camilo Ríos y Manuel Sánchez<br>
      <b>TENIENTES CORONELES DE CABALLERÍA.</b> Félix Díaz, José D. Bello y Miguel Balcázar<br>
      <b>TENIENTES CORONELES.</b> Franco Escalante, Francisco P. Durán, Pedro Gallegos, Manuel Villar y Dionisio Aragón<br>
      <b>CORONEL DE INGENIEROS.</b> Joaquín Colombres<br>
      <b>TENIENTES CORONELES DE INFANTERÍA.</b> José G. Alcalá, Modesto Arriola, Melquiades Campos, Rafael Ballesteros, Eduardo Delgado, Franco Fernández, Mariano Jiménez, Bruno Lozano, Manuel Mestre y Secundino Prado.<br>
      <b>TENIENTES CORONELES.</b> Antonio Mejía, Joaquín Terán, Francisco Taboada, Lorenzo Vega y Manuel Verna.<br>
      <b>CAPITANES DE INFANTERÍA.</b>  Joaquín Ballesteros, José Ma. Benitez, Perfecto Bravo, Urbano Urrutia, entre otros. <br>
    </p>
    <h5>Ver más:</h5>
    <p><a target="_blank" href=""></a></p>
  </div>
</template>

<script>
export default {
  name: "s22g07",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
